
<template>
  <div id="corp_confirm" class="confirm_area">
    <div class="input_confirm">
      <ul>
        <li v-if="!isPrivateUser">
          <span>会社名：</span>
          <span>{{corpForm.corpName}}</span>
        </li>
        <li v-if="!isPrivateUser">
          <span>支店名・営業所名：</span>
          <span>{{corpForm.corpBranchName}}</span>
        </li>
        <li>
          <span>メールアドレス：</span>
          <span>{{corpForm.email}}</span>
        </li>
        <li>
          <span>電話番号：</span>
          <span>{{corpForm.tel}}</span>
        </li>
        <li>
          <span>FAX番号：</span>
          <span>{{corpForm.fax}}</span>
        </li>
        <li>
          <span>郵便番号：</span>
          <span>{{corpForm.postcd}}</span>
        </li>
        <li>
          <span>住所：</span>
          <span>{{corpForm.state}} {{corpForm.city}}</span>
        </li>
        <li>
          <span>以下住所：</span>
          <span>{{corpForm.street}}</span>
        </li>
        <li v-if="!isEdit">
          <span>招待コード：</span>
          <span>{{corpForm.inviteCode}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  name: 'CorpConfirm',
  components: {
  },
  props: {
    corpForm: Object,
    isPrivateUser: {
      type: Boolean,
      default: false
    },
    isEdit: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  created () {
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/user/DcCorpConfirm.vue